import styled from 'styled-components'



export const FirstPanel = styled.div`
  height: 100vh;
  width: 100vw;
  position: relative;
  display: flex;
  background-color: ${props => props.color};
  background-image: url("${props => props.image}");
  background-size: cover;
  background-position: center center;
  align-items: flex-end;
  @media (min-width: 768px){
    align-items: center;
    margin: 0;
  }
  &:before{
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    opacity: .45;
    background: ${props => props.theme.colors.black.primary};

  }
`



export const Loading = styled.div`
position: absolute;
top: 0;
left: 0;
bottom: 0;
background-color: ${props => props.theme.colors.black.primary};
right: 0;
display: flex;
align-items: center;
justify-content: center;
color: ${props => props.theme.colors.primary};
font-size: 2rem;
opacity: .85;

`
export const Panel = styled.div`
  height: 100vh;
  width: 100vw;
  position: relative;
  display: flex;
  background-color: ${props => props.color};
  align-items: center;
`

export const FirstSceneWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  opacity: 0;
  margin-bottom: 2rem;
  @media (min-width: 768px){
    flex-direction: row;
    margin-top: 3rem;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
  }
`;



export const ExagonIconWrapper = styled.div`
  flex-basis:100%;
  z-index: 1;
  
  svg{
    width: 100%;
    height: 40vh;
  }
  text {
    font-size: 1.75rem;
    letter-spacing: .04rem;
    pointer-events: none;
  }
  rect {
    pointer-events: none;
  }
  path{
    transition: .2s all;
    &:hover{
      opacity: .7;
      cursor: pointer;
    }
  } 
  @media (min-width: 768px){
    flex-basis: 40%;
    heigth: auto;
  }
`

export const Content = styled.div`
  text-align: left;
  flex-basis: 100%;
  z-index: 1;

 
  @media (min-width: 768px){
    flex-basis: 60%;
    padding-left: 5rem;
  }
`

export const PageTitleWrapper = styled.div`
  position: absolute;
  top: 6rem;
  left: 0;
  right: 0;
  z-index: 1;
  
`;
export const PageTitle = styled.h1`
  opacity: 0;
  color: white;
`;
export const Title = styled.h2`
  line-height: 1;
  margin-bottom: 1rem;
  color: white;
`;
export const Description = styled.h3`
 color: white;
`;


export const PanelHeader = styled.div`

  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
  font-size: 1.25rem;
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
 
  @media (min-width: 768px){
    position: absolute;
    left: 1rem;
    top: 2rem;
    right: auto;
    left: 50%;
    transform: translate(-50%,0);
  }




`


export const SmallExagonIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: .5rem;
  svg {
    width: 35px;
    height: 35px;
  }
`


export const Slide = styled.div`
  height: 75vh;
  overflow: hidden;

  @media (min-width: 768px){
    height: 60vh;
  }
`

export const IconPlayWrapper = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  @media (min-width: 768px){
    top: 2rem;
    right: 2rem;
  }

`

export const ScrollUpIconWrapper = styled.div`
  display: none;
  position: absolute;
  bottom: 2rem;
  right: 2rem;
  font-size: 2rem;
  color: ${props => props.theme.colors.thirdary};
  z-index: 1;
  transition: .2s color;
  &:hover{
    color: ${props => props.theme.colors.primary};
    cursor: pointer;
  }

   
  @media (min-width: 768px){
    display: block;
  }
`